import { useEffect, useState } from "react";
import { toast } from "react-toastify";
// components
import OwnerSelectField from "./Field/OwnerSelectField";

// services
import { getOwner } from "../../services/GlobalRoles/getOwner";
import { useQuery } from "react-query";
import { useFieldArray } from "react-hook-form";

const OwnersSelect = ({ formEdit, ownersData }) => {
  const [totalPercentage, setTotalPercentage] = useState(0);

  const errorsEdit = formEdit.formState.errors;

  const { data: owners, isLoading: loadingOwners } = useQuery({
    queryKey: ["owners"],
    queryFn: () => getOwner(),
  });

  const { fields, append, remove, update } = useFieldArray({
    control: formEdit.control,
    name: "ownerFields",
  });

  const onChangeHolder = (index) => {
    fields.forEach((field, i) => {
      const currentFieldValues = formEdit.getValues(`ownerFields.${i}`);
      update(i, { ...currentFieldValues, holder: i === index });
    });
  };

  const handleInputChange = (index) => {
    let val = parseFloat(formEdit.getValues(`ownerFields.${index}.percentage`));
    if (isNaN(val)) val = 0;
    const ownerFields = formEdit.getValues("ownerFields") || [];
    const totalPercentages = ownerFields.map((p) =>
      p.percentage ? parseFloat(p.percentage) : 0
    );
    const somaOutros = totalPercentages.reduce(
      (acc, curr, i) => (i !== index ? acc + (parseFloat(curr) || 0) : acc),
      0
    );

    const maxPermitido = 100 - somaOutros;

    if (val > maxPermitido) {
      val = maxPermitido;
      toast.warn("O total de participação não pode ultrapassar 100%.", {
        autoClose: 3000,
      });
    }

    val = Math.round(val * 100) / 100;

    // Atualiza o valor do input editado
    formEdit.setValue(`ownerFields.${index}.percentage`, val);

    // Recalcula total incluindo o valor ajustado
    const updatedPercentages = totalPercentages.map((p, i) =>
      i === index ? val : p
    );

    let total = updatedPercentages.reduce((acc, curr) => acc + curr, 0);

    if (total > 100) {
      const excedente = total - 100;

      // Calcula o total excluindo o valor editado (para redistribuir proporcionalmente)
      const totalOutros = updatedPercentages.reduce(
        (acc, curr, i) => (i !== index ? acc + curr : acc),
        0
      );

      // Redistribui proporcionalmente o excedente entre os outros campos
      updatedPercentages.forEach((value, i) => {
        if (i !== index) {
          const proporcao = value / totalOutros;
          const novoValor = value - excedente * proporcao;
          formEdit.setValue(
            `ownerFields.${i}.percentage`,
            Math.round(novoValor * 100) / 100
          );
        }
      });

      // Atualiza total após redistribuição
      const finalPercentages = formEdit
        .getValues("ownerFields")
        .map((p) => (p.percentage ? parseFloat(p.percentage) : 0));
      total = finalPercentages.reduce((acc, curr) => acc + curr, 0);

      toast.warn(
        "Os valores foram redistribuídos para ajustar o total a 100%.",
        {
          autoClose: 3000,
        }
      );
    }

    setTotalPercentage(total);

    // console.log("Total de participação atualizado:", total);
  };

  const getFormErrorMessage = (name) => {
    return errorsEdit[name] ? (
      <small className="p-error">{errorsEdit[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const handleAddOwner = () => {
    append({ user_id: null, percentage: 0, holder: false });
  };

  const handleRemoveOwner = (index) => {
    remove(index);
  };

  const handleOwnerChange = (selectedOwnerId, index) => {
    let currentOwnerExists = false;
    formEdit.getValues().ownerFields.map((field, i) => {
      if (field.user_id === selectedOwnerId && i !== index) {
        currentOwnerExists = true;
      }
    });
    if (currentOwnerExists) {
      toast.warn("Este proprietário já foi selecionado.");
      formEdit.setValue(`ownerFields.${index}.user_id`, "");
      return;
    }
  };

  useEffect(() => {
    if (ownersData && ownersData.length > 0) {
      const ownerArray = Array.isArray(ownersData)
        ? ownersData
        : Object.values(ownersData);
      formEdit.reset({
        ownerFields: ownerArray.map((owner) => ({
          user_id: owner.user_id || null,
          percentage: owner.percentage || 0,
          holder: owner.holder || false,
        })),
      });

      const total = ownerArray.reduce(
        (sum, o) => sum + (parseFloat(o.percentage) || 0),
        0
      );
      setTotalPercentage(total);
    } else if (!ownersData || fields.length === 0) {
      append({ user_id: null, percentage: 0, holder: false });
      setTotalPercentage(0);
    }
  }, [ownersData, formEdit]);

  return (
    <>
      <div>
        {fields.map((field, index) => (
          <OwnerSelectField
            key={field.id}
            ownerField={field}
            index={index}
            loadingOwners={loadingOwners}
            owners={owners}
            errorsEdit={errorsEdit}
            formEdit={formEdit}
            handleInputChange={() => handleInputChange(index)}
            onChangeHolder={() => onChangeHolder(index)}
            getFormErrorMessage={getFormErrorMessage}
            handleAddOwner={handleAddOwner}
            handleOwnerChange={handleOwnerChange}
            handleRemoveOwner={() => handleRemoveOwner(index)}
            canRemove={fields.length > 1}
          />
        ))}
      </div>
    </>
  );
};

export default OwnersSelect;
